var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDedos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 292,
    height: 209.959,
    viewBox: "0 0 292 209.959",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1831",
    "data-name": "Grupo 1831",
    transform: "translate(-55.667 -280)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1822",
    "data-name": "Grupo 1822",
    transform: "translate(55.667 281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1821",
    "data-name": "Grupo 1821",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6041",
    "data-name": "Trazado 6041",
    d: "M116.26,224.292l-.235-19.751-13.4-11.036a32.307,32.307,0,0,1-6.782-7.694S91.555,173.3,82.825,164.569c-3.813-3.813-4.579-9.506-5.931-13.239h0a51.467,51.467,0,0,0-6.056-11.74L64,129.694a4.042,4.042,0,0,1,1.564-5.937h0a14.482,14.482,0,0,1,14.338.986h0a61.56,61.56,0,0,1,16.369,16.04l1.94,2.786a6.676,6.676,0,0,0,8.6,2.085h0l-.615-27.447-2.341-70.765a9.65,9.65,0,0,1,4.006-8.15h0a7.274,7.274,0,0,1,7.4-.654h0a7.275,7.275,0,0,1,4.106,6.007L127,108.336a1.03,1.03,0,0,0,1.274.877h0a1.03,1.03,0,0,0,.778-.93l3.27-47.84,1.405-25.986a8.229,8.229,0,0,1,4.966-6.287h0a8.23,8.23,0,0,1,8.137,1.043l.658.5a8.233,8.233,0,0,1,3.254,6.556l-.268,71.549a1.031,1.031,0,0,0,.818,1.012l.869.185,5.663-61.343c1-8.177,5.783-9.789,8.88-9.425,5.223.615,7.255,3.672,7.4,9.139.424,16.066-1.558,62.148-1.821,68.15a1.019,1.019,0,0,0,.55.951l.985.519,10.144-50.6a7.191,7.191,0,0,1,10.21-3.045h0c2.864,1.732,3.17,4.116,3.11,8.392,0,0-5.445,47.578-6.869,56.87L186.1,190.152a22.842,22.842,0,0,1-4.928,11.039l-3.087,3.759-.165,18.769a9.731,9.731,0,0,1-7.637,10.477h0a102.993,102.993,0,0,1-39.7.709l-6.3-1.121A9.73,9.73,0,0,1,116.26,224.292Z",
    transform: "translate(-63.279 -27.54)",
    fill: "#fad9b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6042",
    "data-name": "Trazado 6042",
    d: "M139.691,227.378a33.571,33.571,0,0,1-18.87-6.746l.121,10.176C123.694,228.056,133.98,228,139.691,227.378Z",
    transform: "translate(-68.074 -43.631)",
    fill: "#f9c3a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6043",
    "data-name": "Trazado 6043",
    d: "M171.9,227.335c5.5.372,14.433-2.992,15.187.273l.058-6.529S182.714,225.705,171.9,227.335Z",
    transform: "translate(-72.331 -43.668)",
    fill: "#f9c3a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6044",
    "data-name": "Trazado 6044",
    d: "M154.574,182.537c2.03,3.64,2.252-23.509-17.463-33.187-6.47-3.176-22.378-5.582-27.052-12.027l.391,17.479a6.654,6.654,0,0,1-3.471.763C112.173,154.931,140.439,157.183,154.574,182.537Z",
    transform: "translate(-66.921 -36.689)",
    fill: "#f9c3a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6045",
    "data-name": "Trazado 6045",
    d: "M194.377,135.015c.278-1.893.674-4.915,1.139-8.621-4.53,11.445-16.2-1.074-17.213-5.443l-.61,3.041-.985-.519a1.02,1.02,0,0,1-.55-.952c.039-.9.116-2.682.218-5.125-3.594,8.769-18.265,2.47-19.937-5.738l-.4,4.343-.869-.185a1.031,1.031,0,0,1-.818-1.012l.014-3.463a8.361,8.361,0,0,1-4.192,4.406c-4.739,2.166-13.415,2.66-17.027-3.659l-.217,3.181a1.03,1.03,0,0,1-.778.93h0a1.03,1.03,0,0,1-1.274-.877l-.4-3.371c-1.1,6.057-16.68,8.607-20.66,5.354l.093,2.809c11.893-2.315,30.935-4.108,45.807-.938A123.331,123.331,0,0,1,194.377,135.015Z",
    transform: "translate(-67.157 -34.523)",
    fill: "#f9c3a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6046",
    "data-name": "Trazado 6046",
    d: "M178.9,178.094",
    transform: "translate(-72.914 -40.086)",
    fill: "#fbd2bb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_246",
    "data-name": "Elipse 246",
    transform: "translate(39.333 11)",
    fill: "#89c34a",
    stroke: "#89c34a",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_247",
    "data-name": "Elipse 247",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(70 -1)",
    fill: "#89c34a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_248",
    "data-name": "Elipse 248",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(94 10)",
    fill: "#89c34a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_249",
    "data-name": "Elipse 249",
    cx: 9.5,
    cy: 9,
    rx: 9.5,
    ry: 9,
    transform: "translate(117 34)",
    fill: "#89c34a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1830",
    "data-name": "Grupo 1830",
    transform: "translate(211.667 281)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1821-2",
    "data-name": "Grupo 1821",
    transform: "translate(1.994 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6041-2",
    "data-name": "Trazado 6041",
    d: "M144.3,224.292l.235-19.751,13.4-11.036a32.307,32.307,0,0,0,6.782-7.694s4.287-12.511,13.018-21.242c3.813-3.813,4.579-9.506,5.931-13.239h0a51.466,51.466,0,0,1,6.055-11.74l6.841-9.9A4.042,4.042,0,0,0,195,123.757h0a14.482,14.482,0,0,0-14.338.986h0a61.56,61.56,0,0,0-16.369,16.04l-1.94,2.786a6.676,6.676,0,0,1-8.6,2.085h0l.615-27.447,2.341-70.765a9.65,9.65,0,0,0-4.006-8.15h0a7.274,7.274,0,0,0-7.4-.654h0a7.275,7.275,0,0,0-4.106,6.007l-7.635,63.692a1.03,1.03,0,0,1-1.274.877h0a1.03,1.03,0,0,1-.778-.93l-3.27-47.84L126.84,34.458a8.229,8.229,0,0,0-4.966-6.287h0a8.23,8.23,0,0,0-8.137,1.043l-.658.5a8.233,8.233,0,0,0-3.254,6.556l.268,71.549a1.031,1.031,0,0,1-.818,1.012l-.869.185-5.663-61.343c-1-8.177-5.783-9.789-8.88-9.425-5.223.615-7.255,3.672-7.4,9.139-.424,16.066,1.558,62.148,1.821,68.15a1.019,1.019,0,0,1-.55.951l-.985.519-10.144-50.6A7.191,7.191,0,0,0,66.4,63.366h0c-2.864,1.732-3.17,4.116-3.11,8.392,0,0,5.445,47.578,6.869,56.87l4.307,61.524a22.842,22.842,0,0,0,4.928,11.039l3.087,3.759.165,18.769A9.731,9.731,0,0,0,90.278,234.2h0a102.993,102.993,0,0,0,39.7.709l6.3-1.121A9.73,9.73,0,0,0,144.3,224.292Z",
    transform: "translate(-63.279 -27.54)",
    fill: "#fad9b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6042-2",
    "data-name": "Trazado 6042",
    d: "M120.821,227.378a33.571,33.571,0,0,0,18.87-6.746l-.121,10.176C136.819,228.056,126.533,228,120.821,227.378Z",
    transform: "translate(-58.432 -43.631)",
    fill: "#f9c3a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6043-2",
    "data-name": "Trazado 6043",
    d: "M187.14,227.335c-5.5.372-14.433-2.992-15.187.273l-.058-6.529S176.322,225.705,187.14,227.335Z",
    transform: "translate(-152.698 -43.668)",
    fill: "#f9c3a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6044-2",
    "data-name": "Trazado 6044",
    d: "M107.879,182.537c-2.03,3.64-2.252-23.509,17.463-33.187,6.47-3.176,22.378-5.582,27.052-12.027L152,154.8a6.654,6.654,0,0,0,3.471.763C150.28,154.931,122.014,157.183,107.879,182.537Z",
    transform: "translate(-61.526 -36.689)",
    fill: "#f9c3a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6045-2",
    "data-name": "Trazado 6045",
    d: "M110.949,135.015c-.278-1.893-.674-4.915-1.139-8.621,4.53,11.446,16.2-1.074,17.213-5.443l.61,3.041.985-.519a1.02,1.02,0,0,0,.55-.952c-.039-.9-.116-2.682-.218-5.125,3.594,8.769,18.265,2.47,19.937-5.738l.4,4.343.869-.185a1.031,1.031,0,0,0,.818-1.012l-.014-3.463a8.361,8.361,0,0,0,4.192,4.406c4.739,2.166,13.415,2.66,17.027-3.659l.217,3.181a1.03,1.03,0,0,0,.778.93h0a1.03,1.03,0,0,0,1.274-.877l.4-3.371c1.1,6.057,16.68,8.607,20.66,5.354l-.093,2.809c-11.893-2.315-30.935-4.108-45.807-.938A123.33,123.33,0,0,0,110.949,135.015Z",
    transform: "translate(-104.163 -34.523)",
    fill: "#f9c3a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6046-2",
    "data-name": "Trazado 6046",
    d: "M178.9,178.094",
    transform: "translate(-150.874 -40.086)",
    fill: "#fbd2bb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_246-2",
    "data-name": "Elipse 246",
    transform: "translate(77.667 11)",
    fill: "#89c34a",
    stroke: "#89c34a",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.5,
    cy: 9.5,
    rx: 9.5,
    ry: 9.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.5,
    cy: 9.5,
    rx: 8.5,
    ry: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_247-2",
    "data-name": "Elipse 247",
    cx: 9,
    cy: 9,
    rx: 9,
    ry: 9,
    transform: "translate(48 -1)",
    fill: "#89c34a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_248-2",
    "data-name": "Elipse 248",
    cx: 9,
    cy: 9,
    rx: 9,
    ry: 9,
    transform: "translate(24 10)",
    fill: "#89c34a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_249-2",
    "data-name": "Elipse 249",
    cx: 9.5,
    cy: 9,
    rx: 9.5,
    ry: 9,
    transform: "translate(0 34)",
    fill: "#89c34a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDedos);
export default __webpack_public_path__ + "static/media/dedos.08636a026e6527716444a77c26a0464f.svg";
export { ForwardRef as ReactComponent };